import React from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { setToken, login } from "../../Redux/Actions/Authentication";
import { ReactComponent as Edit } from "../../assets/icons/edit.svg";
import { ReactComponent as Exit } from "../../assets/icons/logout.svg";
export const ProfileInfo = ({ name, text }) => {
  return (
    <div>
      <span>{text}</span>
      <span>{name}</span>
    </div>
  );
};

const ProfileInformation = ({
  name,
  mobileNumber,
  email,
  setEdit,
  setToken,
  logOut
}) => {
  const history = useHistory();
  return (
    <>
      <div className="ProfileInformation">
        <ProfileInfo name={"نام و نام خانوادگی"} text={name} />
        <ProfileInfo name={"شماره همراه"} text={mobileNumber} />
        <ProfileInfo name={"ایمیل"} text={email} />
      </div>
      <div onClick={() => setEdit(true)} className="LoginButton EditProfileBtn">
        <span>ویرایش اطلاعات کاربری</span>
        <Edit />
      </div>
      <div
        className="LoginButton Exitbutton"
        onClick={() => {
          setToken();
          logOut();
          history.push("/");
        }}
      >
        خروج از حساب کاربری
        <Exit />
      </div>
    </>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    setToken: () => dispatch(setToken("")),
    logOut: () => dispatch(login(false))
  };
};

export default connect(null, mapDispatchToProps)(ProfileInformation);
